// extracted by mini-css-extract-plugin
export default {"copyButton":"CopyIconButton_copyButton__GGeYb"};